module.exports = __webpack_public_path__ + "static/media/Close-white.41bd052d.svg";